var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectreports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2266 15.9453H11.4766V4.69531H15.2266V15.9453ZM12.7266 5.94531V14.6953H13.9766V5.94531H12.7266ZM10.2266 15.9453H6.47656V7.19531H10.2266V15.9453ZM7.72656 8.44531V14.6953H8.97656V8.44531H7.72656ZM1.47656 0.945312H18.9766V19.6953H1.47656V15.9453H0.226562V14.6953H1.47656V7.19531H0.226562V5.94531H1.47656V0.945312ZM17.7266 18.4453V2.19531H2.72656V5.94531H3.97656V7.19531H2.72656V14.6953H3.97656V15.9453H2.72656V18.4453H17.7266Z",
    fill: "#D12232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectreports);
export default __webpack_public_path__ + "static/media/directreports.11ebfe90379e5f7092ab7e506daf4651.svg";
export { ForwardRef as ReactComponent };